<ul class="lang-dropdown" [class.channels]="isChannels">
  <li *ngIf="translate.currentLang" [value]="translate.currentLang" class="selected-lang">
    <span >{{translate.currentLang.toUpperCase()}}</span>
    <i class="selected-item-arrow material-icons arrow-down">keyboard_arrow_down</i>
    <i class="selected-item-arrow material-icons arrow-up">keyboard_arrow_up</i>
  </li>
  <li *ngFor="let lang of filterTranslations(translate.currentLang); index as i"
      [value]="lang"
      (click)="useAndUpdateLang(lang)"
      [ngStyle]="{'top': (i+1)*56 + 'px'}"
      class="listed">
    <span >{{lang.toUpperCase()}}</span>
  </li>
</ul>
